import React, { useEffect } from "react";

import { FormSubscribe } from "@performyard/py-components";

type UnsavedChangesTrackerProps = {
	id: string;
	setIsUnsafe: () => void;
	setIsSafe: () => void;
};

type UnsavedChangesTrackerInnerProps = {
	isDirty: boolean;
	setIsUnsafe: () => void;
	setIsSafe: () => void;
};

const UnsavedChangesTrackerInner = ({ isDirty, setIsUnsafe, setIsSafe }: UnsavedChangesTrackerInnerProps) => {
	useEffect(() => {
		if (isDirty) {
			setIsUnsafe();
		} else {
			setIsSafe();
		}
	}, [isDirty, setIsUnsafe, setIsSafe]);
	return null;
};

export const UnsavedChangesTracker = ({ id, setIsUnsafe, setIsSafe }: UnsavedChangesTrackerProps) => {
	return (
		<FormSubscribe id={id} selector={(state) => [state?.isDirty]}>
			{([isDirty]) => (
				<UnsavedChangesTrackerInner isDirty={isDirty} setIsUnsafe={setIsUnsafe} setIsSafe={setIsSafe} />
			)}
		</FormSubscribe>
	);
};
